angular.module("app").controller("CategoriesAddPageController", [
    '$scope',
    'preloadedData',
    'pageStatuses',
    'casinoCategoryService',
    'errorHandler',
    'logger',
    '$stateParams',
    function ($scope, preloadedData, pageStatuses, casinoCategoryService, errorHandler, logger, $stateParams) {

        $scope.tooltip = {
            name: "",
            title: ""
        };

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
            casinoCategoryService.create({casinoCategory: $scope.categoryData}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        init();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isForItem = function () {
            return !isNaN(+$stateParams.itemId)
        };

        function init () {
            $scope.categoryData = {
                parent_id: $stateParams.itemId || 0,
                name: "",
                title: "",
                status: pageStatuses[0],
                show_subcategories: false
            };
            $scope.parents = angular.copy(preloadedData.categories);

            !$scope.isForItem() && $scope.parents.unshift({name: "No Parent", id: 0});
            $scope.add_category_form && $scope.add_category_form.$setPristine();
        }

        init();

    }
]);